// 给action注册事件处理函数。当这个函数被触发时候，将状态提交到mutations中处理
// export function modifyAName({commit}, name) { // commit 提交；name即为点击后传递过来的参数，此时是 'A餐馆'
//     return commit ('modifyAName', name)
// }
// export function modifyBName({commit}, name) {
//     return commit ('modifyBName', name)
// }

// ES6精简写法
//  export const modifyAName = ({commit},name) => commit('modifyAName', name)

export function ChangeProductName({commit}, name) {
    return commit('ChangeProductName', name)
}
export function ChangeProductlist({ commit }, prpductnewlist) {
    return commit('ChangeProductlist', prpductnewlist)
}
export function ChangeYwwpicRight ({ commit }, newYwwpicRight) {
    return commit('ChangeYwwpicRight', newYwwpicRight)
}
export function ChangeYwwLagre ({ commit }, newYwwLagre) {
    return commit('ChangeYwwLagre', newYwwLagre)
}
export function ChangeXiancai ({ commit }, newXiancai) {
    return commit('ChangeXiancai', newXiancai)
}
export function ChangeBaozhuang ({ commit }, newBaozhuang) {
    return commit('ChangeBaozhuang', newBaozhuang)
}
export function ChangeDesginList ({ commit }, newDesginList) {
    return commit('ChangeDesginList', newDesginList)
}
export function ChangeSum ({ commit }, newsum) {
    return commit('ChangeSum', newsum)
}
export function ChangePnumber ({ commit }, newPnumber) {
    return commit('ChangePnumber', newPnumber)
}
export function ChangeAllsum ({ commit }, newAllSum) {
    return commit('ChangeAllsum', newAllSum)
}
export function ChangeSelectDesign ({ commit }, newSelectDesign) {
    return commit('ChangeSelectDesign', newSelectDesign)
}
export function ChangeCustomUplod ({ commit }, newCustomUplod) {
    return commit('ChangeCustomUplod', newCustomUplod)
}
export function Changelogostylenumber ({ commit }, newlogostylenumber) {
    return commit('Changelogostylenumber', newlogostylenumber)
}
export function ChangelogoColornumber({ commit }, newlogoColornumber) {
    return commit('ChangelogoColornumber', newlogoColornumber)
}
export function ChangeSumPrice ({ commit }, newSumPrice) {
    return commit('ChangeSumPrice', newSumPrice)
}
export function ChangeDesignMake ({ commit }, newDesignMake) {
    return commit('ChangeDesignMake', newDesignMake)
}
export function ChangeChildproductlist ({ commit }, newChildproductliste) {
    return commit('ChangeChildproductlist', newChildproductliste)
}
export function Changeaddinfo ({ commit }, newaddinfo) {
    return commit('Changeaddinfo', newaddinfo)
}
export function ChangetabbarList ({ commit }, newtabbarList) {
    return commit('ChangetabbarList', newtabbarList)
}
export function Changetokenid ({ commit }, newtokenid) {
    return commit('Changetokenid', newtokenid)
}
export function Changeukey ({ commit }, newukey) {
    return commit('Changeukey', newukey)
}
export function Changemakelist ({ commit }, newmakelist) {
    return commit('Changemakelist', newmakelist)
}


// const actions = {
//     ChangeChildproductlist (commit) {
//         this.$axios.post("/api/public/index/getproduct", {}).then(res => {
 
//             commit.state.newDesignMake = res.data.productList[1].list
//     });
//   },
// }
 
// ChangeChildproductlist(commit){
//     this.$axios.post("/api/public/index/getproduct").then(
//         res => {
//             // console.log('请求成功',res.data);
//             commit.state.newDesignMake= res.data.productList[0].list
//             // console.log(res.data)

           
//         },
      
//     );
// },


// WEBPACK FOOTER //
// ./src/store/actions.js